import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import DocumentPersonalIcon from '@/common/icons/DocumentPersonal.svg';

import { StepCard } from '@/components/step-card';

import { EVENT } from '@/common/constants';
import { useEventAgent } from '@/common/hooks/useEventAgent';
import { useStepper } from '@/components/stepper';
import { useNotification } from '@/components/notification';
import { useFaceAuth } from '@/common/hooks/useFaceAuth';

import { CircleCheckIcon } from './circle-check-icon';

function DocumentPersonal() {
  const { t } = useTranslation();
  const { trackEvent } = useEventAgent();
  const { onStepClick } = useStepper();
  const { setError } = useNotification();
  const { doEnrollmentOcr } = useFaceAuth({
    callback: (result) => {
      if (result?.status === 0) {
        if (result?.isCompletelyDone) {
          trackEvent(EVENT.DOCUMENT_SENT_SUCCESSFULLY_PAGE_VIEW);
          onStepClick(2);
        } else {
          trackEvent(EVENT.INVALID_DOCUMENT_ERROR_PAGE_VIEW, { status: result?.status });
          trackEvent(EVENT.DOCUMENT_VALIDATION_ERROR, { status: result?.status });
          setError('orc-custom', () => {
            onStepClick(0);
          });
        }
      } else {
        if (result?.status === 12) {
          trackEvent(EVENT.CAMERA_PERMISSION_ERROR);
        } else if (result?.status === 18) {
          trackEvent(EVENT.NETWORK_ERROR);
          trackEvent(EVENT.DOCUMENT_QUALITY_ERROR);
          trackEvent(EVENT.DOCUMENT_UPLOAD_ERROR);
        }
        setError('try-again');
      }
    }
  });

  const handleOpenCamera = async(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    doEnrollmentOcr();
  };

  useEffect(() => {
    trackEvent(EVENT.DOCUMENTS_REGISTRATION_PAGE_VIEW);
  }, []);

  return (
    <StepCard
      icon={DocumentPersonalIcon}
      title={t('documentPersonal.title')}
      buttonText={t('documentPersonal.buttonText')}
      onButtonClick={handleOpenCamera}
    >
      <>
        <p className="mb-4">{t('documentPersonal.tips.header')}</p>
        <ul>
          <li className="mb-4 flex items-center">
            <CircleCheckIcon /> {t('documentPersonal.tips.tip1')}
          </li>
          <li className="mb-4 flex items-center">
            <CircleCheckIcon /> {t('documentPersonal.tips.tip2')}
          </li>
          <li className="mb-4 flex items-center">
            <CircleCheckIcon /> {t('documentPersonal.tips.tip3')}
          </li>
        </ul>
      </>
    </StepCard>
  );
}

export default DocumentPersonal;
